import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import RichText from '../RichText'
import Hyperlink from '../HyperLink'
import styles from './index.module.scss'

const DEFAULT_CTA_TEXT = 'Learn more'

const hasRichTextContent = (node) => {
  if (!node) {
    return false
  }

  if (typeof node.value === 'string' && node.value.trim()) {
    return true
  }

  return Array.isArray(node.content) && node.content.some(hasRichTextContent)
}

const isCtaBlock = (type) =>
  String(type || '')
    .replace(/[\s_-]/g, '')
    .toLowerCase() === 'ctablock'

const CalloutBox = ({ type, title, body, link, linkText }) => {
  const showTitle = hasRichTextContent(title)
  const showBody = hasRichTextContent(body)

  if (!showTitle && !showBody) {
    return null
  }

  const cta = isCtaBlock(type)
  const showButton = cta && Boolean(link)

  return (
    <div
      data-testid="callout-box"
      data-type={cta ? 'CtaBlock' : 'callout'}
      className={classNames(
        styles.callout,
        'my-8 flex flex-col gap-4 rounded-lg p-6',
        cta ? 'bg-blue-135 text-center' : 'bg-cream-base'
      )}
    >
      {showTitle ? (
        <RichText
          contentData={title}
          className={classNames('callout-box-title', styles.calloutTitle)}
        />
      ) : null}
      {showBody ? (
        <RichText
          contentData={body}
          className="callout-box-body flex flex-col gap-3"
        />
      ) : null}
      {showButton ? (
        <Hyperlink
          href={link}
          childrenClassNames="cursor-pointer self-center rounded-lg bg-blue-base px-6 py-3 text-center text-lg font-bold leading-6 text-white"
        >
          {linkText || DEFAULT_CTA_TEXT}
        </Hyperlink>
      ) : null}
    </div>
  )
}

CalloutBox.defaultProps = {
  type: 'callout',
  title: null,
  body: null,
  link: '',
  linkText: '',
}

CalloutBox.propTypes = {
  type: PropTypes.string,
  title: PropTypes.object,
  body: PropTypes.object,
  link: PropTypes.string,
  linkText: PropTypes.string,
}

export default React.memo(CalloutBox)
